"use client";
import React from "react";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import SecurityServicesTabs from "@/components/pageTabs/securityServicesTabs";
import WhyOneMindComponent from "./components/whyOneMind";
import EnhancementsComp from "./components/enhancements";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import DescComponent from "./components/desc";
import VulnerabilitySecStack from "./components/secStack";

const VulnerabilityPatchManagementPage = () => {
  return (
    <Box>
      <Hero />
      <PageLayout>
        <SecurityServicesTabs />
        <Intro />
      </PageLayout>
      <DescComponent />
      <PageLayout>
        <WhyOneMindComponent />
      </PageLayout>
      <EnhancementsComp />
      <PageLayout showContactForm>
        <VulnerabilitySecStack />
        <Faqs />
      </PageLayout>
    </Box>
  );
};

export default VulnerabilityPatchManagementPage;
